var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 3,
    fill: "url(#paint0_linear_1454_21193)",
    stroke: "black",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1454_21193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.29716 9.35913C8.29716 8.91753 8.65244 8.56226 9.09404 8.56226H10.1565C10.5981 8.56226 10.9534 8.91753 10.9534 9.35913V13.3435H11.4847C11.9263 13.3435 12.2815 13.6988 12.2815 14.1404C12.2815 14.582 11.9263 14.9373 11.4847 14.9373H8.82841C8.38681 14.9373 8.03154 14.582 8.03154 14.1404C8.03154 13.6988 8.38681 13.3435 8.82841 13.3435H9.35966V10.156H9.09404C8.65244 10.156 8.29716 9.80073 8.29716 9.35913ZM10.379 18.8287C10.1632 18.583 9.77138 18.5996 9.58213 18.8685L9.21025 19.3832C8.95459 19.7417 8.45654 19.8248 8.09795 19.5691C7.73935 19.3134 7.65634 18.8154 7.91201 18.4568L8.28056 17.9388C9.06748 16.8365 10.6811 16.7568 11.5743 17.7761C12.2815 18.5863 12.2649 19.7982 11.5378 20.5884L10.3823 21.8435H11.4847C11.9263 21.8435 12.2815 22.1988 12.2815 22.6404C12.2815 23.082 11.9263 23.4373 11.4847 23.4373H8.56279C8.24736 23.4373 7.95849 23.2513 7.83232 22.9591C7.70615 22.6669 7.76259 22.3316 7.97509 22.0992L10.3657 19.5093C10.5417 19.3167 10.545 19.0246 10.3757 18.8287H10.379ZM14.9378 9.62476H23.4378C24.0255 9.62476 24.5003 10.0996 24.5003 10.6873C24.5003 11.275 24.0255 11.7498 23.4378 11.7498H14.9378C14.3501 11.7498 13.8753 11.275 13.8753 10.6873C13.8753 10.0996 14.3501 9.62476 14.9378 9.62476ZM14.9378 14.9373H23.4378C24.0255 14.9373 24.5003 15.4121 24.5003 15.9998C24.5003 16.5875 24.0255 17.0623 23.4378 17.0623H14.9378C14.3501 17.0623 13.8753 16.5875 13.8753 15.9998C13.8753 15.4121 14.3501 14.9373 14.9378 14.9373ZM14.9378 20.2498H23.4378C24.0255 20.2498 24.5003 20.7246 24.5003 21.3123C24.5003 21.9 24.0255 22.3748 23.4378 22.3748H14.9378C14.3501 22.3748 13.8753 21.9 13.8753 21.3123C13.8753 20.7246 14.3501 20.2498 14.9378 20.2498Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1454_21193",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7209B7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1454_21193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(7.5 7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.a172dba66932e6a6854a8182d9c4fae1.svg";
export { ForwardRef as ReactComponent };